import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { NOT_APPROVED_PATH } from '../../utils/paths';

interface Props {
  children?: ReactNode;
  auth?: boolean;
  isPending?: boolean;
}

const ProtectedRoute: React.FC<Props> = ({ children, auth, isPending }) => {
  if (isPending) return null;

  if (!auth) {
    return <Navigate to={NOT_APPROVED_PATH} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
